import { render, staticRenderFns } from "./ModalTestComplete.vue?vue&type=template&id=30365ffa&scoped=true"
import script from "./ModalTestComplete.vue?vue&type=script&lang=js"
export * from "./ModalTestComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30365ffa",
  null
  
)

export default component.exports